<template>
  <page-outline :title="$t('contacts.imprt_cntcts')"
    iconF7="list_bullet" returnUrl="/contacts/">

    <template slot="pageContent">
      <b-row class="m-0 pb-3">
        <b-col cols="2">
          <back-button :returnUrl="returnUrl"></back-button>
        </b-col>
      </b-row>
      <b-row class="form-group justify-content-md-end">
        <b-col cols="5" sm="4" md="2" class="mr-md-5 mr-lg-5 mr-xl-0">
          <label class="fileContainer attachmentImportButtonLength fs-13px w-150px">
            Choose file
            <input ref="fileInput" type="file" name="file2" id="file2" class="" @change="onFileChange"></input>
          </label>
        </b-col>
        <b-col cols="7" sm="8" md="5" class="ml-md-5 ml-lg-0">
          <input class="form-control" name="filename" placeholder="Choose file" type="text" v-model="attachmentName" disabled></input>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3" lg="2" offset-md="9" offset-lg="10">
          <b-button variant="primary" size="lg"
            @click="importAttachment">
            <f7-icon f7="list_bullet" size="17px"></f7-icon>
            <span>{{ $t('common.imprt') }}</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline'

import {loadPage} from '@/helpers/routing'
import backButton from '@/components/common/backButton.vue'

export default {
  name: 'importAttachement',
  components: {
    'back-button': backButton,
    'page-outline': PageOutline
  },
  data () {
    return {
      isSmartphone: false,
      tesseract: '',
      typeAttachment: '',
      mimeType: '',
      attachment: '',
      attachmentName: '',
      reference: '',
      newOCRTextData: '',
      returnUrl: '/contacts/'
    }
  },
  created: function () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.typeAttachment = ''
    this.mimeType = ''
    this.attachment = ''
    this.attachmentName = ''
    this.reference = ''
    this.fileInput = ''
    // this.$refs.fileInput.value = null
  },
  methods: {
    importAttachment () {
      let that = this
      if (that.attachment !== '' && that.attachmentName !== '') {
        this.$f7.showPreloader('Importing Contacts')
        that.$engine.contacts
          .importContacts(
            this.typeAttachment,
            that.attachment.split(';')[0].split('/')[1],
            that.attachmentName,
            that.attachment.split(';')[1].substring(7)
          )
          .then(response => {
            that.$f7.closeModal()
            that.$f7.hidePreloader()
            that.status = response.status
            if (response.status === 200) {
              that.typeAttachment = ''
              that.mimeType = ''
              that.attachment = ''
              that.attachmentName = ''
              that.reference = ''
              that.newOCRTextData = ''
              that.$$(that.$$('#file2')[that.$$('#file2').length - 1]).val('')
              // document.getElementById('file2').value = ''
              that.$bus.$emit('refresh-cache-contacts')
              that.$f7.modal({
                title: 'Contacts imported',
                text: '<span class="preloader"></span>'
              })
              setTimeout(function () {
                that.$f7.closeModal()
                // loadPage(that, {url: '/attachments/', force: false, ignoreCache: false})
                loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
                // that.$f7.mainView.router.back()
                // loadPage(that, {url: '/attachments/'})
              }, 2000)
            }
          })
          .catch(error => {
            that.$f7.closeModal()
            that.$f7.hidePreloader()
            this.handleError(error) // mixins errorHandlerMixins
          })
      } else {
        that.$f7.alert('', 'Data missing')
      }
    },
    onFileChange (e) {
      /* eslint-disable no-undef */
      let that = this
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 1000000) {
        that.createImage(files[0])
        that.attachmentName = files[0].name
        that.mimeType = files[0].type
      } else {
        that.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 1MB', 'Maximum file size exceeded')
      }
      /* eslint-enable no-undef */
    },
    createImage (file) {
      let reader = new FileReader()
      let that = this
      this.$f7.modal({
        title: 'Charging File',
        text: '<span class="preloader"></span>'
      })
      reader.onload = (e) => {
        that.attachment = e.target.result
        that.$f7.closeModal()
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (e) {
      this.attachment = ''
    }
  }
}
</script>
<style scoped>
.fileContainer [type=file] {
    display: none;
    color: white;
}
.fileContainer {
  border: 1px solid #ffd210;
  text-decoration: none;
  text-align: center;
  border-radius: 27px;
  line-height: 25px;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  padding: 0 10px;
  margin: 0;
  height: 27px;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  outline: 0;
  width: auto;
  float: right;
}
.progressbar {
  height: 8px;
}
</style>
